<template>
    <div class="execution-steps">
        <ul class="execution-steps__list">
            <li class="execution-steps__item"
                v-for="(step, idx) in steps"
                :key="step.title">
                <ExecutionStep
                    :title="step.title"
                    :description="step.description"
                    :icon-name="step.iconName"
                    :order-number="idx + 1"
                    />
            </li>
        </ul>
        <p class="execution-steps__comment">
            *Оплата списывается с карты автоматически раз в месяц. Если передумаете, подписку можно отключить.
        </p>
    </div>
</template>

<script>
import ExecutionStep from '@/components/ui/ExecutionStep';
export default {
    name: 'ExecutionSteps',
    components: {
        ExecutionStep
    },
    data() {
        return {
            steps: [
                {
                    title: 'Выберите программу страхования',
                    description: 'Мы собрали самые востребованные наборы рисков в удобные пакеты, вам остается только выбрать комфортную цену.',
                    iconName: 'app',
                },
                {
                    title: 'Заполните данные для оформления полиса',
                    description: 'Форма онлайн оформления позволит предзаполнить большинство данных и сэкономить время.',
                    iconName: 'edit-pen',
                },
                {
                    title: 'Оплатите и получите полис бизнес картой',
                    description: 'Договор придет на вашу электронную почту. Плата за подписку на новый месяц спишется автоматически.',
                    iconName: 'money',
                }
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.execution-steps {
    &__list {
        display: flex;
        justify-content: space-between;

        @media #{$screen-medium} {
            flex-direction: column;
        }
    }

    &__item {
        @include flex-width-three-in-row($gap-normal);

        @media #{$screen-medium} {
            @include resetting-vertical-indentation-of-first;

            width: 100%;

            margin-top: rem($gap-normal);
        }
    }

    &__comment {
        @include text-normal($font-weight-regular, $line-height-normal);

        margin-top: rem($gap-big);

        color: $primary;

        opacity: .5;

        @media #{$screen-medium} {
            font-size: rem($font-size-small);
        }
    }
}
</style>